import React, { useContext } from 'react';
import { Field, useField, useFormState } from 'react-final-form';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { HelpIcon } from '@motorway/mw-highway-code';
import { Intent } from '@motorway/mw-highway-code/src/types';

import cypressIds from 'CypressId';

import { getFieldState, INTENT, requiredValidator } from 'Utilities/formValidators';
import { applyCypressData } from 'Utilities/index';

import { InputLabel } from 'Components/inputLabel/InputLabel';
import { FeedbackTooltip } from 'Storybook/components/local/FeedbackTooltip/FeedbackTooltip';

import LocalTexts from '../../DocumentCapture.texts.json';
import { AddBankDetailsContext, AddBankDetailsContextType } from '../AddBankDetailsContext';

import { RadioControl } from './helpers/RadioControl/RadioControl';

import styles from './fields.scss';

const LocalT = new MDText(LocalTexts.addBankDetails.fields.accountType);

export const ACCOUNT_TYPE_FIELD_NAME = 'isBusiness';

const AccountType = () => {
  const {
    accountTypeErrorMessage,
    displayAccountTypeErrorMessage,
  }: AddBankDetailsContextType = useContext(AddBankDetailsContext);

  const { submitting: disabled } = useFormState();
  const { meta } = useField(ACCOUNT_TYPE_FIELD_NAME);

  const content = displayAccountTypeErrorMessage ? accountTypeErrorMessage : meta.error;
  const intent = displayAccountTypeErrorMessage && !meta.modifiedSinceLastSubmit
    ? INTENT.ERROR
    : getFieldState(meta) as Intent;

  const intentClass = intent ? styles[intent] : '';

  return (
    <div className={cx(styles.accountType, {
      [styles[intentClass]]: !displayAccountTypeErrorMessage,
    })}
    >
      <div>
        <InputLabel
          labelText={LocalT.translate('label')}
          tooltip={LocalT.translate('hint')}
        />
        <FeedbackTooltip
          {...{ content, intent }}
          placementFlipped={displayAccountTypeErrorMessage ? 'top' : 'bottom'}
          theme={displayAccountTypeErrorMessage ? 'warning' : undefined}
          tooltipIcon={displayAccountTypeErrorMessage ? <HelpIcon /> : undefined}
        >
          <div className={styles.accountTypeRadioList} {...applyCypressData(cypressIds.radios.radioList)}>
            <Field
              name={ACCOUNT_TYPE_FIELD_NAME}
              type="radio"
              validate={requiredValidator(LocalT.translate('errorMessage'))}
              value="false"
            >
              {({ input }) => (
                <RadioControl disabled={disabled} displayText={LocalT.translate('personal') as string} id='account-type-personal' inputProps={input} />
              )}
            </Field>
            <Field
              name={ACCOUNT_TYPE_FIELD_NAME}
              type="radio"
              validate={requiredValidator(LocalT.translate('errorMessage'))}
              value="true"
            >
              {({ input }) => (
                <RadioControl disabled={disabled} displayText={LocalT.translate('business') as string} id='account-type-business' inputProps={input} />
              )}
            </Field>
          </div>
        </FeedbackTooltip>
      </div>
    </div>
  );
};

export default AccountType;
